import { Block } from 'components/Block'
import { SCard, SCardsWrapper, SInfoBlockWrapper } from './SecurityInfoBlock.styled'
import { Icon, IconName } from 'components/icon'
import { Spacer } from 'components/spacer/Spacer'
import { Stack } from 'components/Stack'
import { Caption, Text, Title, Title_h2_default } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { colors } from 'utils/colors'
import { NumberRange } from 'utils/types'

const icons: Record<NumberRange<4>, IconName> = {
  '1': 'ShieldCheck',
  '2': 'LockClosed',
  '3': 'Key',
  '4': 'LockClosed',
}

const translationKeys = {
  title: 'security.info_block_title',
  box1Title: 'security.info_box_1_title',
  box1Desc: 'security.info_box_1_desc',
  box2Title: 'security.info_box_2_title',
  box2Desc: 'security.info_box_2_desc',
  box3Title: 'security.info_box_3_title',
  box3Desc: 'security.info_box_3_desc',
  box4Title: 'security.info_box_4_title',
  box4Desc: 'security.info_box_4_desc',
} as const

export function SecurityInfoBlock() {
  const { t } = useTranslation('security')

  return (
    <Block css={{ overflow: 'hidden' }}>
      <SInfoBlockWrapper>
        <Title variant={Title_h2_default} as="h2">
          {t(translationKeys.title)}
        </Title>

        <Spacer size={[1.5, 4]} />

        <SCardsWrapper>
          <Stack space={[2, 4]} css={{ width: '100%' }}>
            <Stack
              space={[2, 4]}
              css={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10rem' }}
            >
              <SCard>
                <Icon name={icons['1']} />
                <Stack space={10}>
                  <Caption css={{ color: colors.gray[100] }}>
                    {t(translationKeys.box1Title)}
                  </Caption>
                  <Text>{t(translationKeys.box1Desc)}</Text>
                </Stack>
              </SCard>
              <SCard>
                <Icon name={icons['2']} />
                <Stack space={10}>
                  <Caption css={{ color: colors.gray[100] }}>
                    {t(translationKeys.box2Title)}
                  </Caption>
                  <Text>{t(translationKeys.box2Desc)}</Text>
                </Stack>
              </SCard>
            </Stack>
            <Stack
              space={[2, 4]}
              css={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10rem' }}
            >
              <SCard>
                <Icon name={icons['3']} />
                <Stack space={10}>
                  <Caption css={{ color: colors.gray[100] }}>
                    {t(translationKeys.box3Title)}
                  </Caption>
                  <Text>{t(translationKeys.box3Desc)}</Text>
                </Stack>
              </SCard>
              <SCard>
                <Icon name={icons['4']} />
                <Stack space={10}>
                  <Caption css={{ color: colors.gray[100] }}>
                    {t(translationKeys.box4Title)}
                  </Caption>
                  <Text>{t(translationKeys.box4Desc)}</Text>
                </Stack>
              </SCard>
            </Stack>
          </Stack>
        </SCardsWrapper>
      </SInfoBlockWrapper>
    </Block>
  )
}
